__turbopack_context__.v({
  "appear": "errorBase-module-scss-module__uno4eq__appear",
  "button": "errorBase-module-scss-module__uno4eq__button",
  "heroSubtitle": "errorBase-module-scss-module__uno4eq__heroSubtitle",
  "heroTitle": "errorBase-module-scss-module__uno4eq__heroTitle",
});
